import { SPELL_MAP } from '../../data/spells';

const ALT_KEYS = ['Z', 'X', 'C', 'V'];

/**
 * A single spell hotbar slot.
 *
 * Props:
 *   index          — slot position 0–3
 *   spellId        — id of the equipped spell, or null/undefined for an empty slot
 *   spellCooldowns — map of spellId → last-cast timestamp
 *   onCast         — (slotIndex) → void
 */
export function SpellSlot({ index, spellId, spellCooldowns, onCast }) {
  const now      = performance.now();
  const spell    = spellId ? SPELL_MAP[spellId] : null;
  const lastCast = spellId ? (spellCooldowns?.[spellId] ?? -Infinity) : -Infinity;
  const elapsed  = now - lastCast;
  const onCd     = spell && elapsed < spell.cooldown;
  const cdPct    = onCd ? ((spell.cooldown - elapsed) / spell.cooldown) * 100 : 0;
  const cdSec    = onCd ? ((spell.cooldown - elapsed) / 1000).toFixed(1) : null;

  return (
    <div
      data-mobile-btn="true"
      className={`spell-slot${onCd ? ' spell-slot--cooldown' : ''}${!spell ? ' spell-slot--empty' : ''}`}
      onClick={() => onCast?.(index)}
    >
      {onCd && (
        <div className="spell-slot-cd-overlay" style={{ height: `${cdPct}%` }} />
      )}

      <span className="spell-slot-key">
        {index + 1}<span className="spell-slot-altkey">{ALT_KEYS[index]}</span>
      </span>

      {spell ? (
        <>
          <span className="spell-slot-icon">{spell.icon}</span>
          <span className="spell-slot-name">{spell.label}</span>
          {cdSec && <span className="spell-slot-cd-text">{cdSec}s</span>}
        </>
      ) : (
        <span className="spell-slot-icon spell-slot-icon--empty">—</span>
      )}
    </div>
  );
}
